module.exports = __webpack_public_path__ + "img/img5-4.e8df5cc1.jpg";